module.exports = __webpack_public_path__ + "static/img/vip_preview.6ad7e032.png";